import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  defaultTooltip: {
    backgroundColor: "#93A9BD",
    color: "#FFFFF",
    padding: "4px 12px",
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "24px",
    width: "fit-content !important",
    maxWidth: "500px",
  },
}));

export const TextEllipsis = styled("div")(() => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export default styles;
